export const getDiscourseChatUrl = (): string => {
  const configuredChatUrl = import.meta.env.VITE_DISCOURSE_CHAT_URL as string | undefined;
  const discourseUrl = (import.meta.env.VITE_DISCOURSE_URL as string | undefined)?.replace(/\/+$/, '');

  return configuredChatUrl || (discourseUrl ? `${discourseUrl}/chat` : '');
};

export const getDiscourseActivationUrl = (returnUrl?: string): string => {
  const chatUrl = getDiscourseChatUrl();
  const configuredDiscourseUrl = import.meta.env.VITE_DISCOURSE_URL as string | undefined;

  if (!chatUrl) {
    return '';
  }

  try {
    const discourseUrl = new URL(configuredDiscourseUrl || chatUrl);
    let destinationUrl = new URL(chatUrl, discourseUrl);

    if (returnUrl) {
      const arkReturnUrl = new URL(returnUrl, window.location.origin);
      if (arkReturnUrl.origin !== window.location.origin) {
        return chatUrl;
      }
      destinationUrl = arkReturnUrl;
    }

    if (!returnUrl && destinationUrl.origin !== discourseUrl.origin) {
      return chatUrl;
    }

    const activationUrl = new URL(discourseUrl);
    const discourseBasePath = discourseUrl.pathname.replace(/\/+$/, '');
    activationUrl.pathname = `${discourseBasePath}/session/sso`;
    activationUrl.search = '';
    activationUrl.hash = '';
    activationUrl.searchParams.set('return_path', destinationUrl.origin === discourseUrl.origin
      ? `${destinationUrl.pathname}${destinationUrl.search}${destinationUrl.hash}`
      : destinationUrl.toString());

    return activationUrl.toString();
  } catch {
    return chatUrl;
  }
};
